<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="배너 조회"
      desc="등록된 배너의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end">
      <button @click="$router.push('banner/create')"
              class="button is-primary">배너 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 :table_width="700"
                 @selPageLength="selPageLength">


      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <!--<button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>-->
      </div>

    </admin-table>

    <!--<sweet-modal overlay-theme="dark" ref="deleteModal">
      <lp-modal>
        <span slot="title">기획전 삭제</span>
        <span slot="desc">기획전 항목을 삭제하시겠습니까?</span>
        <span slot="ok" @click="deleteItem">확인</span>
        <span slot="cancel" @click="$refs.deleteModal.close()">취소</span>
      </lp-modal>
    </sweet-modal>-->

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'BannerList',
    mixins: [
      ListMixin
    ],

    created() {
      this.init();
    },

    methods: {
      init () {
        this.initializing('banner', 'banner');
      },
      getDataFromServer() {
        this.getData();
      },
      imgField(img) {
        return 'background-image: url('+this.image(img)+');' +
          ' width: 20px; height: 20px; background-size: cover;' +
          ' background-position: center; margin-right: 8px';
      },
      clickItem(item, kind) {
        if ( kind === 'update' ) {
          this.$router.push(this.getPath('banner/create?id='+item.id));
        }
        else if ( kind === 'delete' ) {
          let value = {
            id: item.id,
            url: 'banner/',
            title: '배너를 삭제하시겠습니까?'
          }

          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },

      deleteItem(){
        this.$axios.delete(this.getUrl('banner') + this.modalItem)
          .then(res => {
            if (res.status === 200) {

            }
          });
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
